import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import EDEStatementsPage from "components/EDEStatements/pages/EDEStatementsPage";
import Classes from "model";
import { useEffect } from "react";

/**
 * @function CaptureMabiEDEStatements
 * @param {OBJECT} props - None used for now.
 * @description - Component for capture "002_Statements" in mabi23 capture group "Statements".
 */
export default function CaptureMabiEDEStatements(props) {
    const context = useBCMSContext();

    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <EDEStatementsPage />
}